<template>
  <div class="select-model">
    <p class="os-font-14-500">选择维修设备</p>
    <div v-if="currentSelectedModel.name" class="selected-model" @click="showModelPopup">
      <div class="model-img">
        <img
          :src="currentSelectedModel.picture || require('@/assets/img/repair/base/wap/phone.png')"
          alt="我的设备"
        />
      </div>
      <div class="model-info">
        <p
          class="os-font-14-500"
          :class="{
            'my-device': currentSelectedModel.isNative == 1,
            'my-phone': currentSelectedModel.isMineProduct
          }"
        >
          <span>{{ currentSelectedModel.name }}</span>
        </p>
      </div>
    </div>
    <div v-else class="not-selected-model" @click="showModelPopup">
      <p class="os-font-14-400">选择设备</p>
    </div>
    <servicePopup ref="modelPopup" :title="'请选择产品型号'">
      <div class="model-popup-content">
        <div class="model-wrapper">
          <div class="series-content">
            <ul>
              <li
                v-for="(model, index) in modelList"
                :key="index"
                :class="[
                  'os-font-12-400',
                  {
                    active: activeSeriesIndex === index,
                    preActive: activeSeriesIndex - 1 === index,
                    nextActive: activeSeriesIndex + 1 === index
                  }
                ]"
                @click="scrollToSeries(index)"
              >
                <p v-if="model.products && model.products.length > 0">
                  <span>{{ model.seriesName }}</span>
                </p>
              </li>
            </ul>
          </div>
          <div class="model-content" @scroll="handleScroll">
            <div v-for="(series, index) in modelList" :key="index">
              <div v-if="series.products && series.products.length > 0">
                <p class="os-font-12-400">
                  <span>{{ series.seriesName }}</span>
                </p>
                <div class="model-list">
                  <div
                    v-for="(model, index) in series.products"
                    :key="index"
                    :class="{
                      active:
                        cacheModel &&
                        cacheModel.code === model.code &&
                        cacheModel.picture === model.picture &&
                        cacheModel.isNative === model.isNative,
                      'my-device': model.isNative === 1
                    }"
                    @click="selectModel(model)"
                  >
                    <div class="model-image">
                      <img
                        :src="model.picture || require('@/assets/img/repair/base/wap/phone.png')"
                        alt="机型图片"
                      />
                    </div>
                    <p class="os-font-12-400">{{ model.name }}</p>
                  </div>
                  <i></i><i></i><i></i><i></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="model-button os-font-16-500">
          <p :class="{ active: hasSelected }" @click="confirmModel">确定</p>
        </div>
      </div>
    </servicePopup>
  </div>
</template>

<script>
import servicePopup from 'components/service-popup/index.vue'
import { mapMutations, mapState } from 'vuex'
import API from 'views/repair/base/api'

export default {
  name: 'selectModel',
  components: { servicePopup },
  data() {
    return {
      currentAnimationFrame: null,
      activeSeriesIndex: 0,
      preIndex: -1,
      nextIndex: 1,
      noHandleScroll: false,
      hasModelList: false,
      // 接口返回的数据结构
      apiModelList: [
        {
          order: null,
          products: [
            {
              id: null,
              name: null,
              code: null,
              seriesId: null,
              categoryId: null,
              picture: null,
              isNative: null,
              sortPositionService: null
            }
          ],
          seriesId: null,
          seriesName: null
        }
      ],
      currentSelectedModel: {
        id: null,
        name: null,
        code: null,
        seriesId: null,
        categoryId: null,
        picture: null,
        isNative: null,
        sortPositionService: null,
        isMineProduct: false
      },
      cacheModel: null,
      hasSelected: false
    }
  },
  computed: {
    ...mapState('repair', ['repairType', 'selectedModel', 'modelList'])
  },
  mounted() {
    this.init()
  },
  methods: {
    ...mapMutations('repair', ['SET_SELECTED_MODEL', 'RESET_STATE', 'SET_MODEL_LIST']),
    init() {
      // 尝试用全局变量中读取已选择的机型
      if (this.selectedModel.id) {
        this.currentSelectedModel = this.selectedModel
        this.selectModel(this.selectedModel)
      }

      // 尝试从全局变量中读取机型列表
      if (this.modelList.length > 0) {
        this.apiModelList = this.modelList
      } else {
        // 获取机型列表
        this.getProducts()
      }
    },
    getProducts() {
      API.getProducts({
        data: {
          type: this.repairType
        }
      })
        .then(res => {
          if (res.code === 0) {
            this.dataProcess(res.data)
          } else {
            console.log(res.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    dataProcess(data) {
      // 初始化自动选中的机型，优先级 缓存机型 -> 本机 -> 账户关联的第一个机型
      let nativePhone
      let hasModel
      this.apiModelList = data || []
      if (this.apiModelList && this.apiModelList.length > 0) {
        // 系列排序
        this.apiModelList.sort((a, b) => {
          return a.order - b.order
        })
        // 机型排序
        this.apiModelList.forEach(series => {
          // 去掉重复的数据
          series.products = series.products.reduce((acc, current) => {
            const x = acc.find(
              item =>
                item.id === current.id &&
                item.code === current.code &&
                item.isNative === current.isNative &&
                item.picture === current.picture
            )
            if (!x) {
              return acc.concat([current])
            } else {
              return acc
            }
          }, [])
          // 为机型添加是否为账户关联手机标识
          series.products.forEach(model => {
            this.$set(model, 'isMineProduct', series.isMineProduct)
          })

          // 缓存机型是否可以在机型列表中匹配到
          if (this.selectedModel.code && this.selectedModel && !hasModel) {
            hasModel = series.products.some(model => model.code === this.selectedModel.code)
            if (hasModel) {
              nativePhone = this.selectedModel
            }
          }

          if (!nativePhone) {
            nativePhone = series.products.find(model => {
              return model.isNative
            })
          }

          series.products.sort((a, b) => {
            return a.sortPositionService - b.sortPositionService
          })
        })

        // 自动选中当前机型
        if (nativePhone) {
          this.selectModel(nativePhone)
          this.confirmModel()
        }

        this.hasModelList = true
        this.SET_MODEL_LIST(this.apiModelList)
      } else {
        // 没有数据时重置全局变量
        this.RESET_STATE('modelList')
      }
    },
    selectModel(model) {
      this.hasSelected = true
      this.cacheModel = model
    },
    // 缓动函数 - 近似 cubic-bezier(0.25, 0.45, 0.3, 1)
    cubicBezier(t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1
    },
    /**
     * 平滑滚动方法
     * @param container 滚动容器
     * @param element   滚动元素
     * @param duration  滚动时间
     * @param callback  回调方法
     */
    smoothScrollTo(container, element, duration, callback) {
      // 如果有正在进行的滚动，先取消它
      if (this.currentAnimationFrame) {
        window.cancelAnimationFrame(this.currentAnimationFrame)
      }

      // 滚动的容器
      const scrollContainer = container
      const startingY = scrollContainer.scrollTop
      // 相对于滚动容器的顶部位置
      const targetY = element.offsetTop
      const diff = targetY - startingY
      let start

      if (!diff) return

      const step = timestamp => {
        if (!start) start = timestamp
        const time = timestamp - start
        let percent = Math.min(time / duration, 1)

        // 使用 cubicBezier 函数
        percent = this.cubicBezier(percent)

        scrollContainer.scrollTop = startingY + diff * percent

        if (time < duration) {
          this.currentAnimationFrame = window.requestAnimationFrame(step)
        } else {
          this.currentAnimationFrame = null
          if (callback) callback()
        }
      }

      this.currentAnimationFrame = window.requestAnimationFrame(step)
    },
    /**
     * 滚动到指定的系列
     * @param index
     */
    scrollToSeries(index) {
      this.activeSeriesIndex = index
      this.noHandleScroll = true
      const modelContainer = this.$el.querySelector('.model-content')
      const modelElement = this.$el.querySelectorAll('.model-content > div')[index]
      // 自定义滚动停止前，不处理 handleScroll 事件
      this.smoothScrollTo(modelContainer, modelElement, 250, () => {
        this.noHandleScroll = false
      })
    },
    /**
     * 监听机型的滚动事件，更新 activeSeriesIndex
     * @param event
     */
    handleScroll(event) {
      if (this.noHandleScroll) return
      const scrollTop = event.target.scrollTop
      const seriesElements = this.$el.querySelectorAll('.model-content > div')
      for (let i = 0; i < seriesElements.length; i++) {
        const elem = seriesElements[i]
        if (scrollTop >= elem.offsetTop && scrollTop < elem.offsetTop + elem.offsetHeight / 2) {
          this.activeSeriesIndex = i
          this.preIndex = i - 1
          this.nextIndex = i + 1
          break
        }
      }
    },
    // 展示机型选择
    showModelPopup() {
      this.$nextTick(() => {
        this.$refs.modelPopup.openPopup()
      })
    },
    // 隐藏机型选择
    hideModelPopup() {
      this.$nextTick(() => {
        this.$refs.modelPopup.closePopup()
      })
    },
    // 点击确定按钮
    confirmModel() {
      if (!this.hasSelected) {
        return
      }

      if (this.selectedModel !== this.cacheModel) {
        this.currentSelectedModel = this.cacheModel
        // 重置故障类型列表、配件价格列表
        this.RESET_STATE(['selectedProblemList', 'componentPriceData'])
        // 设置选中的机型
        this.SET_SELECTED_MODEL(this.currentSelectedModel)
      }
      this.hideModelPopup()
    }
  }
}
</script>

<style lang="scss" src="./index.scss" scoped></style>
